export default __webpack_public_path__ + "static/media/single-project-page-01-img4.8531e1ad.jpg";